<div class="container-fluid" *ngIf="exibirComponente">
    <div class="row">

        <div class="col-3 p-0 d-flex">
            <div class="d-flex align-self-center tot-pagina">
              <div class="rotulo"><span class="d-none d-md-inline ">Total de </span>Registros:</div>
              <div class="flex-grow-1 pl-1 rotulo"><strong>{{totalItens}}</strong></div>
            </div>
        </div>

        <div class="col-6 p-0">
            <ng-container *ngIf="exibirPaginacao">
                <div class="d-flex justify-content-center align-items-center">
                    <div class="first-page">
                      <a (click)="primeiraPagina()" class="noselect" nz-tooltip nzTooltipTitle="Primeira Página">
                        <svg width="28px" height="24px" viewBox="0 0 28 24" version="1.1"
                             xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
                          <g id="First-page">
                            <g id="arrow" transform="translate(1.944445 0)">
                              <g id="→-Icon-first-page">
                                <path d="M0 0L24 0L24 24L0 24L0 0Z" id="Rectangle" fill="none" stroke="none" />
                                <path
                                  d="M2 1C2 0.45 1.55 0 1 0C0.45 0 0 0.45 0 1L0 11C0 11.55 0.45 12 1 12C1.55 12 2 11.55 2 11L2 1ZM7.82 6L11.7 9.89C12.0877 10.2745 12.0922 10.9 11.71 11.29C11.32 11.68 10.69 11.68 10.3 11.29L5.71 6.7C5.52277 6.51315 5.41756 6.25951 5.41756 5.995C5.41756 5.73049 5.52277 5.47684 5.71 5.29L10.3 0.7C10.5519 0.448128 10.919 0.34976 11.263 0.441952C11.6071 0.534144 11.8759 0.802888 11.968 1.14695C12.0602 1.49102 11.9619 1.85813 11.71 2.11L7.82 6Z"
                                  transform="translate(6 6)" id="Shape" class="active"
                                  [class.disabled]="isPrimeiraPagina" fill-rule="evenodd" stroke="none" />
                              </g>
                            </g>
                          </g>
                        </svg>
                      </a>
                    </div>
                    <div class="prev-page">
                      <a (click)="paginaAnterior()" class="noselect" nz-tooltip nzTooltipTitle="Página Anterior">
                        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1"
                             xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
                          <defs>
                            <path d="M0 0L22 0L22 22L0 22L0 0Z" id="path_1" />
                            <clipPath id="mask_1">
                              <use xlink:href="#path_1" />
                            </clipPath>
                          </defs>
                          <g id="Icon-right">
                            <g id="arrow-disabled" transform="translate(1 1)">
                              <g id="→-Icon-left">
                                <path d="M0 0L22 0L22 22L0 22L0 0Z" id="Rectangle" fill="none" stroke="none" />
                                <path
                                  d="M6.64408 0.308787C6.4468 0.111096 6.17898 0 5.89969 0C5.62039 0 5.35257 0.111096 5.15529 0.308787L0.308787 5.15529C0.111096 5.35257 0 5.62039 0 5.89969C0 6.17898 0.111096 6.4468 0.308787 6.64408L5.15529 11.4906C5.42124 11.7565 5.80886 11.8604 6.17215 11.7631C6.53545 11.6657 6.81921 11.3819 6.91655 11.0187C7.0139 10.6554 6.91003 10.2677 6.64408 10.0018L2.54726 5.89441L6.64408 1.79758C7.05588 1.38579 7.04532 0.710022 6.64408 0.308787Z"
                                  transform="translate(7.333333 5.5)" id="Path" class="active" stroke="none" />
                              </g>
                            </g>
                          </g>
                        </svg>
                      </a>

                    </div>
                    <div class="d-flex">
                      <ng-container *ngFor="let pagina of paginasVisiveis">

                        <div class="page-number" *ngIf="pagina.ativa" [class.active]="pagina.ativa">
                          {{pagina.numero}}
                        </div>

                        <div class="page-number" *ngIf="!pagina.ativa" (click)="alterarPagina(pagina)">
                          <a class="number noselect">
                            {{pagina.numero}}
                          </a>
                        </div>

                      </ng-container>
                    </div>
                    <div class="next-page">
                      <a (click)="proximaPagina()" class="noselect" nz-tooltip nzTooltipTitle="Próxima Página">
                        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1"
                             xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
                          <defs>
                            <path d="M0 0L22 0L22 22L0 22L0 0Z" id="path_1" />
                            <clipPath id="mask_1">
                              <use xlink:href="#path_1" />
                            </clipPath>
                          </defs>
                          <g id="Icon-right">
                            <g id="next" transform="translate(1 1)">
                              <g id="→-Icon-right">
                                <path d="M0 0L22 0L22 22L0 22L0 0Z" id="Rectangle" fill="none" stroke="none" />
                                <path
                                  d="M0.308784 0.310176C0.111095 0.50746 0 0.775279 0 1.05457C0 1.33386 0.111095 1.60167 0.308784 1.79896L4.40558 5.89575L0.308784 9.99254C0.0428387 10.2585 -0.0610248 10.6461 0.036318 11.0094C0.133661 11.3727 0.417421 11.6565 0.780709 11.7538C1.144 11.8511 1.53162 11.7473 1.79757 11.4813L6.64403 6.63486C6.84172 6.43758 6.95281 6.16976 6.95281 5.89047C6.95281 5.61118 6.84172 5.34337 6.64403 5.14608L1.79757 0.299617C1.39633 -0.101615 0.720575 -0.101615 0.308784 0.310176Z"
                                  transform="translate(7.333333 5.5)" id="Path" class="active" stroke="none" />
                              </g>
                            </g>
                          </g>
                        </svg>
                      </a>
                    </div>
                    <div class="last-page">
                      <a (click)="ultimaPagina()" class="noselect" nz-tooltip nzTooltipTitle="Última Página">
                        <svg width="28px" height="24px" viewBox="0 0 28 24" version="1.1"
                             xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
                          <g id="Last-page">
                            <g id="arrow" transform="translate(1.944443 0)">
                              <g id="→-Icon-last-page">
                                <path d="M0 0L24 0L24 24L0 24L0 0Z" id="Rectangle" fill="none" stroke="none" />
                                <path
                                  d="M12.002 1C12.002 0.45 11.552 0 11.002 0C10.452 0 10.002 0.45 10.002 1L10.002 11C10.002 11.55 10.452 12 11.002 12C11.552 12 12.002 11.55 12.002 11L12.002 1ZM4.18204 6L0.292043 2.11C-0.0879567 1.73 -0.0879567 1.09 0.292043 0.7C0.478888 0.512772 0.732534 0.407556 0.997043 0.407556C1.26155 0.407556 1.5152 0.512772 1.70204 0.7L6.29204 5.3C6.47927 5.48684 6.58449 5.74049 6.58449 6.005C6.58449 6.26951 6.47927 6.52316 6.29204 6.71L1.70204 11.3C1.45017 11.5519 1.08306 11.6502 0.738995 11.558C0.394931 11.4659 0.126187 11.1971 0.0339954 10.853C-0.0581963 10.509 0.040171 10.1419 0.292043 9.89L4.18204 6Z"
                                  transform="translate(6 6)" id="Shape" class="active" fill-rule="evenodd"
                                  [class.disabled]="isUltimaPagina" stroke="none" />
                              </g>
                            </g>
                          </g>
                        </svg>
                      </a>
                    </div>
                </div>
            </ng-container>
        </div>

        <div class="col-3 p-0 d-flex justify-content-end">
            <div class="d-flex res-pagina">
                <div class="flex-grow-1 align-self-center pr-2 rotulo d-none d-md-block">Resultados por página:</div>
                <div>
                    <nz-select [(ngModel)]="itemPorPagina" (ngModelChange)="trocarItensPagina()">
                        <nz-option [nzValue]="item" [nzLabel]="item" *ngFor="let item of itemsPorPagina"></nz-option>
                    </nz-select>
                </div>
            </div>
        </div>

    </div>
</div>
